import React, { useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components";

import LogoCards from "../components/Cards/LogoCard";
import BlockchainCard from "../components/Cards/CardContainer";
import CardContainerB from "../components/Cards/CardContainerB";
import Container from "../components/ContentCourse/Container";
import Cube from "../components/FiberElements/City";

/* Tipografía y jerarquía (Merriweather) */
const GlobalStyle = createGlobalStyle`
  html, body { font-family: 'Merriweather', serif; color:#111; background:#fff; }
  h1, h2, h3 { margin:0; letter-spacing:-.5px; }
  h1 { font-size:44px; line-height:1.1; font-weight:800; }
  h2 { font-size:34px; line-height:1.2; font-weight:700; margin-bottom:12px; }
  h3 { font-size:26px; line-height:1.25; font-weight:600; margin-bottom:8px; }
  p, li { font-size:17px; line-height:1.7; color:#222; }
  blockquote {
    margin:18px 0 0; padding:12px 16px;
    border-left:3px solid #0d6efd; background:#fafafa;
    font-weight:800; font-size:28px; color:#d00000;
  }
`;

const Page = styled.div``;

const ContainerWrap = styled.section`
  max-width: 960px;
  margin: 0 auto;
  padding: 24px;
`;

const Separator = styled.hr`
  border: 0; margin: 0;
`;

const Band = styled.section`

  background: #f5f7fb;
`;

const Hero = styled.div`
  position: relative;
  height: 360px;               /* un poco más alto para lucir la animación */
  overflow: hidden;

  /* Capa de animación */
  .cubebg {
    position: absolute;
    inset: 0;
    z-index: 0;                /* detrás de todo */
    opacity: .35;              /* visible pero sutil */
    pointer-events: none;      /* no bloquea interacciones */
  }

  /* Velo para legibilidad sobre la animación */
  .veil {
    position: absolute;
    inset: 0;
    z-index: 1;
   
  }

  /* Contenido */
  .inner {
    position: relative;
    z-index: 2;                /* por encima de la animación y velo */
    height: 100%;
    display: flex;
    align-items: center;
  }

  /* Panel translucido (sin radios) */
  .panel {
 

    padding: 24px;
  }
`;

const Card = styled.div`
  background: #fff;

  padding: 24px;               /* sin border-radius: recto */

`;

const TwoCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  @media (max-width: 960px) { grid-template-columns: 1fr; }
`;

export default function AboutUs() {
  useEffect(() => { document.title = "UVEG & CoachBlockchain — Conócenos"; }, []);

  return (
    <Page>
      <GlobalStyle />

      {/* HERO */}
      <Band>
        <Hero>
          <div className="cubebg"><Cube /></div>
          <div className="veil" />
          <ContainerWrap className="inner">
            <div className="panel">
              <h1>UVEG & CoachBlockchain</h1>
              <p style={{ fontSize: 18, lineHeight: 1.6, color: "#444", marginTop: 8, maxWidth: 820 }}>
                Alianza académica para impulsar talento Web3 con certificaciones, práctica guiada
                y proyectos reales en blockchain, cripto y seguridad.
              </p>
            </div>
          </ContainerWrap>
        </Hero>
      </Band>

      {/* Logos */}
      <ContainerWrap style={{ marginTop: 32 }}>
        <Card style={{ background: "#ffffffff" }}>
          <LogoCards />
        </Card>
      </ContainerWrap>

      {/* Consejo Consultivo (1 columna) */}
      <ContainerWrap style={{ marginTop: 56 }}>
        <h2>Consejo Consultivo de Blockchain</h2>
        <Card>
          <h3>El Consejo Consultivo</h3>
          <p>
            Red de expertos reconocidos por UVEG y CoachBlockchain como líderes en cripto, DeFi,
            seguridad y desarrollo. Aseguran estándares de calidad y ética en las certificaciones
            y las mantienen actualizadas frente a los avances del sector.
          </p>
          <ul style={{ marginTop: 12, paddingLeft: 18 }}>
            <li>Monitoreo de lineamientos y mejores prácticas de certificación.</li>
            <li>Vinculación con la industria y revisión de planes de estudio.</li>
            <li>Mentoría y revisión técnica de proyectos aplicados.</li>
          </ul>
        </Card>
      </ContainerWrap>

      {/* Datos cortos (2 columnas) */}
      <ContainerWrap style={{ marginTop: 56 }}>
        <TwoCol>
          <Card>
            <h3>Transparencia y nuevas oportunidades</h3>
            <p>
              La mayor fortaleza de blockchain es la transparencia y trazabilidad. Esto ha
              disparado la demanda profesional, con roles que requieren desde seguridad y
              desarrollo hasta DeFi y tokenización.
            </p>
            <blockquote>
              Actualmente hay <b>14 ofertas</b> de empleo por cada profesional de blockchain
            </blockquote>
          </Card>

          <Card>
            <h3>Mercado Global</h3>
            <h2 style={{ fontSize: 36, margin: "8px 0" }}>$41.2 mil millones USD</h2>
            <p>
              Valor estimado del mercado global de blockchain en <strong>2025</strong>.
              Fuente: <em>Precedence Research</em> (2025).
            </p>

          </Card>
        </TwoCol>
      </ContainerWrap>

      {/* Quiénes somos (1 columna) */}
      <ContainerWrap style={{ marginTop: 56 }}>
        <Card>
          <h3>¿Quiénes somos y qué hacemos?</h3>
          <p>
            La Universidad Virtual del Estado de Guanajuato (UVEG) y CoachBlockchain se han unido
            para una alianza estratégica que revoluciona la educación en blockchain y tecnologías
            emergentes. Ofrecemos certificaciones y programas enfocados en:
          </p>
          <ul style={{ marginTop: 10, paddingLeft: 18 }}>
            <li>Blockchain y Transformación Digital Empresarial.</li>
            <li>Gestión de Proyectos Digitales y Marketing Digital.</li>
            <li>Tokenización de Activos y Ecosistemas DeFi.</li>
          </ul>

          <h3 style={{ marginTop: 22 }}>Misión de la Colaboración</h3>
          <p>
            Formar profesionales con herramientas digitales actuales, pensamiento crítico y enfoque
            productivo, conectados con la industria y proyectos reales.
          </p>

          <h3 style={{ marginTop: 22 }}>Educación para el Futuro</h3>
          <p>
            Los programas están diseñados para prosperar en economías digitales y ecosistemas
            centrados en el usuario: finanzas descentralizadas, mercados centrados en el usuario y
            automatización inteligente.
          </p>
        </Card>
      </ContainerWrap>

      {/* Bloques existentes */}
      <ContainerWrap style={{ marginTop: 56 }}>
        <TwoCol>
          <Card style={{ padding: 16 }}>
            <BlockchainCard />
          </Card>
          <Card style={{ padding: 16 }}>
            <CardContainerB />
          </Card>
        </TwoCol>
      </ContainerWrap>

      {/* Módulos adicionales */}
      <ContainerWrap style={{ marginTop: 56 }}>
        <Card style={{ background: "#ffffffff" }}>
          <Container />
        </Card>
      </ContainerWrap>

      <Separator />
    </Page>
  );
}
